import PropTypes from "prop-types";
import styles from "../CustomNavbar.module.css";

const ProvidersGrid = ({providers = [], onItemClick, className = ""}) => {
  return (
    <div className={`${styles.providersGrid} ${className}`}>
      {providers.map(provider => (
        <div
          key={provider.code}
          className={styles.providerCard}
          onClick={e => onItemClick?.(provider, e)}
          title={provider.label}
        >
          <img
            src={provider.avatar}
            alt={provider.label}
            className={styles.providerAvatar}
          />
        </div>
      ))}
    </div>
  );
};

ProvidersGrid.propTypes = {
  providers: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
      key: PropTypes.string,
    })
  ),
  onItemClick: PropTypes.func,
  className: PropTypes.string,
};

export default ProvidersGrid;
